import { render, staticRenderFns } from "./OutboxTable.vue?vue&type=template&id=b8bd31da&scoped=true&"
import script from "./OutboxTable.vue?vue&type=script&lang=js&"
export * from "./OutboxTable.vue?vue&type=script&lang=js&"
import style0 from "./OutboxTable.vue?vue&type=style&index=0&id=b8bd31da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bd31da",
  null
  
)

export default component.exports